// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,json_types=true"
// @generated from file shift_plan.proto (package raccoonai, syntax proto2)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { ShiftPlanType, ShiftPlanTypeJson } from "./enums_pb";
import { file_enums } from "./enums_pb";
import type { Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file shift_plan.proto.
 */
export const file_shift_plan: GenFile = /*@__PURE__*/
  fileDesc("ChBzaGlmdF9wbGFuLnByb3RvEglyYWNjb29uYWkiuQIKCVNoaWZ0UGxhbhIKCgJpZBgBIAIoBBI0ChVvd25lcl9vcmdhbml6YXRpb25faWQYAiACKARSFW93bmVyX29yZ2FuaXphdGlvbl9pZBIcCglkcml2ZXJfaWQYAyACKARSCWRyaXZlcl9pZBIcCglwbGFuX2RhdGUYBCACKAlSCXBsYW5fZGF0ZRI2CglwbGFuX3R5cGUYBSACKA4yGC5yYWNjb29uYWkuU2hpZnRQbGFuVHlwZVIJcGxhbl90eXBlEjoKCmNyZWF0ZWRfYXQYZSABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wUgpjcmVhdGVkX2F0EjoKCnVwZGF0ZWRfYXQYZiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wUgp1cGRhdGVkX2F0IrsBCg9TaGlmdFBsYW5DcmVhdGUSNAoVb3duZXJfb3JnYW5pemF0aW9uX2lkGAEgAigEUhVvd25lcl9vcmdhbml6YXRpb25faWQSHAoJZHJpdmVyX2lkGAIgAigEUglkcml2ZXJfaWQSHAoJcGxhbl9kYXRlGAMgAigJUglwbGFuX2RhdGUSNgoJcGxhbl90eXBlGAQgASgOMhgucmFjY29vbmFpLlNoaWZ0UGxhblR5cGVSCXBsYW5fdHlwZUIGWgQuL3Bi", [file_enums, file_google_protobuf_timestamp]);

/**
 * ShiftPlan is planning intent only: "driver X should work on date D".
 * It never references a truck — vehicles are assigned later, when the actual
 * driver_on_shift record is created. There is no stored status either: the
 * schedule cell state (planned / missed / worked) is derived at read time by
 * ShiftPlanService.ListShiftSchedule from this table and driver_on_shift.
 *
 * @generated from message raccoonai.ShiftPlan
 */
export type ShiftPlan = Message<"raccoonai.ShiftPlan"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: required uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * @generated from field: required uint64 driver_id = 3 [json_name = "driver_id"];
   */
  driverId: bigint;

  /**
   * Calendar date, "YYYY-MM-DD", in the platform business timezone (Asia/Almaty).
   *
   * @generated from field: required string plan_date = 4 [json_name = "plan_date"];
   */
  planDate: string;

  /**
   * @generated from field: required raccoonai.ShiftPlanType plan_type = 5 [json_name = "plan_type"];
   */
  planType: ShiftPlanType;

  /**
   * @generated from field: optional google.protobuf.Timestamp created_at = 101 [json_name = "created_at"];
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp updated_at = 102 [json_name = "updated_at"];
   */
  updatedAt?: Timestamp;
};

/**
 * ShiftPlan is planning intent only: "driver X should work on date D".
 * It never references a truck — vehicles are assigned later, when the actual
 * driver_on_shift record is created. There is no stored status either: the
 * schedule cell state (planned / missed / worked) is derived at read time by
 * ShiftPlanService.ListShiftSchedule from this table and driver_on_shift.
 *
 * @generated from message raccoonai.ShiftPlan
 */
export type ShiftPlanJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: required uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * @generated from field: required uint64 driver_id = 3 [json_name = "driver_id"];
   */
  driver_id?: string;

  /**
   * Calendar date, "YYYY-MM-DD", in the platform business timezone (Asia/Almaty).
   *
   * @generated from field: required string plan_date = 4 [json_name = "plan_date"];
   */
  plan_date?: string;

  /**
   * @generated from field: required raccoonai.ShiftPlanType plan_type = 5 [json_name = "plan_type"];
   */
  plan_type?: ShiftPlanTypeJson;

  /**
   * @generated from field: optional google.protobuf.Timestamp created_at = 101 [json_name = "created_at"];
   */
  created_at?: TimestampJson;

  /**
   * @generated from field: optional google.protobuf.Timestamp updated_at = 102 [json_name = "updated_at"];
   */
  updated_at?: TimestampJson;
};

/**
 * Describes the message raccoonai.ShiftPlan.
 * Use `create(ShiftPlanSchema)` to create a new message.
 */
export const ShiftPlanSchema: GenMessage<ShiftPlan, {jsonType: ShiftPlanJson}> = /*@__PURE__*/
  messageDesc(file_shift_plan, 0);

/**
 * @generated from message raccoonai.ShiftPlanCreate
 */
export type ShiftPlanCreate = Message<"raccoonai.ShiftPlanCreate"> & {
  /**
   * @generated from field: required uint64 owner_organization_id = 1 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * @generated from field: required uint64 driver_id = 2 [json_name = "driver_id"];
   */
  driverId: bigint;

  /**
   * "YYYY-MM-DD"; must be strictly after today in Asia/Almaty.
   *
   * @generated from field: required string plan_date = 3 [json_name = "plan_date"];
   */
  planDate: string;

  /**
   * Sent explicitly rather than cycled server-side; omitted means DAY.
   *
   * @generated from field: optional raccoonai.ShiftPlanType plan_type = 4 [json_name = "plan_type"];
   */
  planType: ShiftPlanType;
};

/**
 * @generated from message raccoonai.ShiftPlanCreate
 */
export type ShiftPlanCreateJson = {
  /**
   * @generated from field: required uint64 owner_organization_id = 1 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * @generated from field: required uint64 driver_id = 2 [json_name = "driver_id"];
   */
  driver_id?: string;

  /**
   * "YYYY-MM-DD"; must be strictly after today in Asia/Almaty.
   *
   * @generated from field: required string plan_date = 3 [json_name = "plan_date"];
   */
  plan_date?: string;

  /**
   * Sent explicitly rather than cycled server-side; omitted means DAY.
   *
   * @generated from field: optional raccoonai.ShiftPlanType plan_type = 4 [json_name = "plan_type"];
   */
  plan_type?: ShiftPlanTypeJson;
};

/**
 * Describes the message raccoonai.ShiftPlanCreate.
 * Use `create(ShiftPlanCreateSchema)` to create a new message.
 */
export const ShiftPlanCreateSchema: GenMessage<ShiftPlanCreate, {jsonType: ShiftPlanCreateJson}> = /*@__PURE__*/
  messageDesc(file_shift_plan, 1);

